import { useRef, useEffect, useState } from "react";
import { Box } from "@mui/material";

export default function ScrollSyncContainer({ children }) {
    const topRef = useRef(null);
    const bottomRef = useRef(null);
    const [showTop, setShowTop] = useState(false);

    const measure = () => {
        const bottom = bottomRef.current;
        if (!bottom) return;

        const content = bottom.querySelector(".scroll-content");
        if (!content) return;

        const fullWidth = content.scrollWidth;
        const viewWidth = bottom.clientWidth;

        const overflow = fullWidth > viewWidth;
        setShowTop(overflow);

        if (overflow && topRef.current) {
            topRef.current.querySelector(".scroll-inner").style.width = `${fullWidth}px`;
        }
    };

    // On mount + resize
    useEffect(() => {
        measure();
        window.addEventListener("resize", measure);
        return () => window.removeEventListener("resize", measure);
    }, []);

    // Sync scrollbars whenever top appears
    useEffect(() => {
        const top = topRef.current;
        const bottom = bottomRef.current;
        if (!bottom) return;

        const syncTop = () => {
            if (bottom && top) bottom.scrollLeft = top.scrollLeft;
        };
        const syncBottom = () => {
            if (bottom && top) top.scrollLeft = bottom.scrollLeft;
        };

        measure();

        if (top) top.addEventListener("scroll", syncTop);
        bottom.addEventListener("scroll", syncBottom);

        return () => {
            if (top) top.removeEventListener("scroll", syncTop);
            bottom.removeEventListener("scroll", syncBottom);
        };
    }, [showTop]);

    return (
        <Box sx={{ width: "100%" }}>
            {/* TOP SCROLLBAR */}
            {showTop && (
                <Box
                    ref={topRef}
                    sx={{
                        overflowX: "auto",
                        height: "16px",
                    }}
                >
                    <Box className="scroll-inner" sx={{ height: 1 }} />
                </Box>
            )}

            {/* BOTTOM SCROLL AREA */}
            <Box
                ref={bottomRef}
                sx={{
                    overflowX: "auto",
                    position: "relative",
                    mt: showTop ? 1 : 0,
                }}
            >
                {/* REAL CONTENT */}
                <Box className="scroll-content">
                    {children}
                </Box>
            </Box>
        </Box>
    );
}
